import { handleActions } from 'redux-actions';
import {
  cleanupAction,
  completeRequest,
  completeSuccess,
  completeError
} from './stakeholderInformationSurveyAction';

const defaultState = {
  isCompleting: false,
  completed: null,
  completeError: null
};

export default handleActions(
  {
    [completeRequest](state) {
      return {
        ...state,
        isCompleting: true,
        completed: false,
        completeError: null
      };
    },
    [completeSuccess](state, { payload }) {
      return {
        ...state,
        isCompleting: false,
        completed: true,
        completeError: null
      };
    },
    [completeError](state, { payload }) {
      return {
        ...state,
        isCompleting: false,
        completed: false,
        completeError: payload
      };
    },
    [cleanupAction](){
      return{
        ...defaultState
      }
    }
  },
  defaultState,
);